import PropTypes from 'prop-types';
import { Box, Typography, alpha } from '@mui/material';
import { Iconify } from 'src/components';

const SCOPE_CONFIGS = {
    treatment: {
        included: ['All active leads', 'Archived leads'],
        excluded: ['Duplicate leads'],
        warnings: ['Spam leads included'],
    },
    source: {
        included: ['All active leads', 'Archived leads'],
        excluded: ['Duplicate leads'],
        warnings: ['Spam leads included'],
    },
    practitioner: {
        included: ['All active leads (by status transition date)'],
        excluded: ['Duplicate leads'],
        warnings: ['Spam leads included'],
    },
};

export default function DataScopeIndicator({ variant }) {
    const config = SCOPE_CONFIGS[variant];
    if (!config) return null;

    return (
        <Box
            sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                px: 2.5,
                py: 1,
                bgcolor: alpha('#3b82f6', 0.04),
                borderBottom: '1px solid',
                borderColor: 'divider',
                flexWrap: 'wrap',
            }}
        >
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Iconify icon="mdi:filter-check-outline" width={14} sx={{ color: '#64748b' }} />
                <Typography sx={{ fontSize: '11px', color: '#64748b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.3px' }}>
                    Data scope
                </Typography>
            </Box>
            {config.included.map((item) => (
                <Box key={item} sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                    <Iconify icon="mdi:check-circle" width={13} sx={{ color: '#10b981' }} />
                    <Typography sx={{ fontSize: '11px', color: '#475569' }}>{item}</Typography>
                </Box>
            ))}
            {config.excluded.map((item) => (
                <Box key={item} sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                    <Iconify icon="mdi:close-circle" width={13} sx={{ color: '#ef4444' }} />
                    <Typography sx={{ fontSize: '11px', color: '#475569' }}>{item}</Typography>
                </Box>
            ))}
            {(config.warnings || []).map((item) => (
                <Box key={item} sx={{ display: 'flex', alignItems: 'center', gap: 0.4 }}>
                    <Iconify icon="mdi:alert-circle" width={13} sx={{ color: '#f59e0b' }} />
                    <Typography sx={{ fontSize: '11px', color: '#475569' }}>{item}</Typography>
                </Box>
            ))}
        </Box>
    );
}

DataScopeIndicator.propTypes = {
    variant: PropTypes.oneOf(['treatment', 'source', 'practitioner']).isRequired,
};
